"use strict";
exports.__esModule = true;
exports.messagesDefault = void 0;
exports.messagesDefault = {
    success: 'Record has been deleted successfully',
    error: 'Something went wrong while trying to delete the record'
};
